import { loadRuntimeConfig } from '@acme/app-shell'

export interface RuntimeConfig {
  authority: string
  clientId: string
  scopes: string
  apiBaseUrl: string
  // ERP API (module of the portal); default /api/erp.
  erpApiBaseUrl?: string
  // Monitoring API (module of the portal); default /api/monitoramento.
  monitoringApiBaseUrl?: string
  // CNPJ analysis API (module of the portal); default /api/analise-cnpj.
  cnpjApiBaseUrl?: string
  // Automação de Envios API (module of the portal); default /api/envios.
  campaignApiBaseUrl?: string
  // Post-logout page (access app), e.g. http://localhost/entrar/saiu?app=assistente.
  postLogoutUrl?: string
}

export const loadPortalConfig = () => loadRuntimeConfig<RuntimeConfig>(['authority', 'clientId', 'scopes', 'apiBaseUrl'])
